const TextStore = {};

TextStore.statuses = {0: 'Inactive',1: 'Active'};
TextStore.header = 'Verify a Computers 4 Kids Certificate';
TextStore.explain1 = 'This tool will allow you to verify the authenticity of a Computers 4 Kids Certificate.';
TextStore.explain2 = ' Enter a certificate number below.';
TextStore.explain3 = 'You can find the certificate number near the bottom of the certificate';

export default TextStore;